// Pricing migration 18 (ADO-2249, AC1): the `Contract price` pill (Figma set 4b, the design
// system's dotless grey "Label Tag"), the same on every surface. A contract price is the
// account's agreed, ongoing price, not a temporary deal, so the pill is grey and the price beside
// it stays navy.

import styles from './ContractPricePill.module.css';

export interface ContractPricePillProps {
  /** Hidden when the surface already says "Contract price" in its spoken price (DEC-15). */
  readonly 'aria-hidden'?: 'true' | undefined;
}

export function ContractPricePill(props: ContractPricePillProps) {
  return (
    <span className={styles.pill} aria-hidden={props['aria-hidden']}>
      Contract price
    </span>
  );
}
